import { render, staticRenderFns } from "./url-zone.vue?vue&type=template&id=b00a8e4a&"
import script from "./url-zone.vue?vue&type=script&lang=ts&"
export * from "./url-zone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports